import { useEffect, useRef } from 'react'

/**
 * 値を常に最新に保つRefを返すフック
 *
 * コールバック関数をuseEffectの依存配列に入れずに安定して参照するために使用。
 * `useRef` + `useEffect` で同期するボイラープレートを1行に削減する。
 *
 * @example
 * const onClickRef = useLatestRef(onClick)
 * // onClickRef.current は常に最新の onClick を参照
 */
export function useLatestRef<T>(value: T): React.RefObject<T> {
  const ref = useRef(value)
  useEffect(() => {
    ref.current = value
  })
  return ref
}
